<template>
    <div class="bankruptcy">
        <b-card no-body class="p-3">
            <b-row align-v="center">
                <b-col cols="6">
                    <h3 class="mb-0">
                        Bankruptcy
                    </h3>
                </b-col>
                <b-col cols="6">
                    <span v-if="bankruptcy_issue.length > 0" class="float-right font-weight-600 text-danger">{{ bankruptcy_issue.length }} Issue{{ bankruptcy_issue.length > 1 ? 's' : '' }}</span>
                    <span v-else class="float-right text-muted">No Issue</span>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>
<script>
import { Card, Button } from 'element-ui'
import { mapState } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'

export default {
    name: 'bankruptcy',
    components: {
        [Card.name]: Card,
        [Button.name]: Button,
    },
    data() {
        return {
            bankruptcy_issue: '',
        }
    },
    computed:{
        ...mapState(useCustomerStore, ['current_commitment'])
    },
    watch: {
        current_commitment: {
            handler(newVal){
                if(newVal){
                    this.bankruptcy_issue = newVal.credit_report_summary.bankruptcies
                }
            }
        }
    }
}
</script>